import { useSyncExternalStore } from "react";
import {
  getCloudHumansUnreadCount,
  subscribeCloudHumansUnreadCount,
} from "@/utils/cloudHumans";

export const useCloudHumansUnreadCount = () =>
  useSyncExternalStore(
    subscribeCloudHumansUnreadCount,
    getCloudHumansUnreadCount,
    getCloudHumansUnreadCount,
  );
